import { render } from "./QueueButton.vue?vue&type=template&id=8ef90414&scoped=true"
import script from "./QueueButton.vue?vue&type=script&lang=js"
export * from "./QueueButton.vue?vue&type=script&lang=js"

import "./QueueButton.vue?vue&type=style&index=0&id=8ef90414&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ef90414"]])

export default __exports__